import { render } from "./ProductDescription.vue?vue&type=template&id=4a79d6c8&scoped=true"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"

import "./ProductDescription.vue?vue&type=style&index=0&id=4a79d6c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a79d6c8"

export default script